// extracted by mini-css-extract-plugin
module.exports = {"Container":"_3mtMx","Contact":"_3e9vK","Metrics":"_10pt3","Domain":"_2gej5","Top":"_3Rj7s","BadgeWrap":"_3uT0F","Tags":"_2toXT"};